import ApplicationsNew from './Application';

export default ApplicationsNew;
